export enum CompanyRole {
    CLIENT      = 1,
    GUEST       = 2,
    USER        = 3,
    MANAGER     = 4,
}

// used for access checks
export enum CompanyAccess {
    CLIENT      = 1,
    GUEST       = 2,
    USER        = 3,
    MANAGER     = 4,
    ADMIN       = 5
}

export const CompanyRoleLabel: any = {
    [CompanyRole.CLIENT]    : 'Client',
    [CompanyRole.GUEST]     : 'Guest',
    [CompanyRole.USER]      : 'User',
    [CompanyRole.MANAGER]   : 'Manager',
}

export const CompanyRoleDescription: any = {
    [CompanyRole.CLIENT]    : '',
    [CompanyRole.GUEST]     : 'External collaborator with access to specific projects; no access to organization-wide data or settings.',
    [CompanyRole.USER]      : 'Standard role with access to assigned work and tools.',
    [CompanyRole.MANAGER]   : 'Has access to all organization tools, settings, and user management.',
}

// is used in setup
export enum CompanyDefaultAccess {
    NONE        = 1,
    ADMIN       = 2,
    MANAGER     = 3,
}

export const CompanyDefaultAccessLabels = {
    [CompanyDefaultAccess.NONE]     : 'None',
    [CompanyDefaultAccess.ADMIN]    : 'Administrators',
    [CompanyDefaultAccess.MANAGER]  : 'Administrators & Managers',
}